import React, { useState } from 'react';
import { useSocket } from '../context/SocketContext';
import { login } from '../services/api';

const LoginPage: React.FC = () => {
  const { setPlayerId: setGlobalPlayerId } = useSocket();
  const [inputPlayerId, setInputPlayerId] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleStart = async () => {
    if (!inputPlayerId.trim()) {
      setError('Please enter your Player ID');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      const result = await login(inputPlayerId.trim());

      if (result.success) {
        setGlobalPlayerId(inputPlayerId.trim());
        // Use full page navigation to fix iOS Safari layout timing issue
        window.location.href = '/lobby?showDisclaimer=true';
      } else {
        setError(result.error || 'Invalid Player ID');
      }
    } catch (e) {
      console.warn('API not available, allowing login for testing');
      setGlobalPlayerId(inputPlayerId.trim());
      // Use full page navigation to fix iOS Safari layout timing issue
      window.location.href = '/lobby?showDisclaimer=true';
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="page bg-[#3C4959] justify-center items-center px-5 py-8">
      {/* Main card */}
      <div className="bg-white border border-black/25 rounded-[48px] py-8 px-6 flex flex-col items-center w-full max-w-[320px]">
        {/* Logo - ¬∧∨ with rounded background */}
        <div className="bg-[#8EA6C0] rounded-full px-5 py-2 mb-5">
          <span className="font-serif text-[22px] font-bold text-[#25384D] tracking-wide">
            ¬∧∨
          </span>
        </div>

        {/* Title box */}
        <div className="bg-[#8EA6C0] rounded-[20px] py-6 px-5 w-full mb-6">
          <h1 className="font-serif text-[22px] font-bold text-[#25384D] text-center leading-[1.3] m-0">
            Master of Practical
            <br />
            Mandarin
          </h1>
        </div>

        {/* Input field */}
        <div className="w-full mb-5">
          <input
            type="text"
            className="w-full py-4 px-6 border-none rounded-full text-base text-center bg-[#8EA6C0] text-[#25384D] outline-none placeholder:text-[#25384D]/60 font-bold"
            placeholder="Enter Player ID"
            value={inputPlayerId}
            onChange={(e) => {
              setInputPlayerId(e.target.value);
              setError('');
            }}
            onKeyPress={(e) => e.key === 'Enter' && !isLoading && handleStart()}
            disabled={isLoading}
          />
          {error && <p className="text-red-400 text-[13px] mt-3 text-center">{error}</p>}
        </div>

        {/* Start button */}
        <button
          className={`bg-[#8EA6C0] text-[#25384D] py-3 px-10 rounded-full font-serif text-lg font-bold border-none transition-all active:scale-[0.97] active:opacity-90 ${isLoading ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
          onClick={handleStart}
          disabled={isLoading}
        >
          {isLoading ? 'Validating...' : 'Start'}
        </button>
      </div>
    </div>
  );
};

export default LoginPage;
